export default __webpack_public_path__ + "664c8b03f6462149ee0fb7042d26e42b.png";